module.exports = __webpack_public_path__ + "static/img/join_us_3.61a0ec71.png";